import { IconButton, styled } from "@mui/material";

export const StyledOpenPickerButton = styled(IconButton)`
  &&& {
    color: ${(props) => props.theme.wsc.palette.neutral[100]};
    padding: ${({
      theme: {
        wsc: { spacing },
      },
    }) => `0 ${spacing[1]} 0 ${spacing[0]}`};
    outline: none;

    &:hover {
      background: none;
    }

    &.Mui-disabled {
      color: ${(props) => props.theme.wsc.palette.neutral[300]};
    }
  }
`;
